import { useRealtimeState } from '@/realtime/react';
import type { ConnectionState } from '@/realtime/types';
import { cn } from '@/lib/cn';

/** Words for the states a person needs to know about. `null` means say nothing. */
export function connectionMessage(
  state: ConnectionState,
): { text: string; tone: 'warn' | 'error' } | null {
  switch (state) {
    case 'connecting':
    case 'reconnecting':
      return { text: 'Reconnecting… live updates are paused.', tone: 'warn' };
    case 'expired':
    case 'unauthorized':
      return { text: 'Your session has ended. Sign in again to get live updates.', tone: 'error' };
    case 'failed':
      return { text: 'Live updates are unavailable.', tone: 'error' };
    default:
      return null;
  }
}

export function ConnectionBannerView({ state }: { state: ConnectionState }) {
  const message = connectionMessage(state);
  // Keep the live region mounted so changes are announced.
  return (
    <div role="status" aria-live="polite">
      {message && (
        <p
          className={cn(
            'px-4 py-2 text-center text-sm font-medium',
            message.tone === 'warn'
              ? 'bg-attention-soft text-attention-ink'
              : 'bg-danger-soft text-danger',
          )}
        >
          {message.text}
        </p>
      )}
    </div>
  );
}

/** Reads the shared staff realtime state. */
export function ConnectionBanner() {
  return <ConnectionBannerView state={useRealtimeState()} />;
}
